<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="secondary" dark class="title" flat>
      <v-icon left>fas fa-minus-circle</v-icon>
      Delete Setting
    </v-toolbar>
    <v-card-text>
      <v-row>
          <v-col cols="12" class="subtitle-1 text-center">
              Are you certain you want to delete the listing for <b>{{selectedSetting.item}}</b>?
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" class="text-center">
            <v-btn @click="cancel()" outlined color="red">
            <v-icon left small>fas fa-times</v-icon>
            Cancel
            </v-btn>
        </v-col>
        <v-col cols="6" class="text-center">
            <v-btn outlined @click="deleteSetting()">
              <v-icon left small>fas fa-check</v-icon>
              Delete Setting
            </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
      selectedSetting: Object
  },
  data(){
    return {
        
    }
  },
  methods: {
    cancel(){
      this.settingInfo = {}
        this.$emit('close')
    },
    deleteSetting(){
        this.$store.dispatch('deleteSetting', this.selectedSetting)
        // this.$emit('close')
    },
  },
  computed: {
    
  }
}
</script>
